document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fp-bh-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.fp-bh-main');
    var slides = main ? main.querySelectorAll('[data-fp-bh-slide]') : [];
    var thumbs = gallery.querySelectorAll('.fp-bh-thumb');
    var prevBtn = main ? main.querySelector('[data-fp-bh-prev]') : null;
    var nextBtn = main ? main.querySelector('[data-fp-bh-next]') : null;

    function showSlide(index) {
      var target = String(index);
      slides.forEach(function (slide) {
        slide.style.display = slide.getAttribute('data-index') === target ? '' : 'none';
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-index') === target);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(thumb.getAttribute('data-index'));
      });
    });

    function currentIndex() {
      var activeThumb = gallery.querySelector('.fp-bh-thumb.is-active');
      return activeThumb ? parseInt(activeThumb.getAttribute('data-index'), 10) : 0;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var next = (currentIndex() - 1 + slides.length) % slides.length;
        showSlide(next);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var next = (currentIndex() + 1) % slides.length;
        showSlide(next);
      });
    }
  });

  document.querySelectorAll('[data-fp-bh-options]').forEach(function (group) {
    var form = group.closest('form');
    if (!form) return;
    var qtyInput = form.querySelector('#fp-bh-quantity');
    var idInput = form.querySelector('input[name="id"]');
    var ctaPrice = form.querySelector('[data-fp-bh-cta-price]');
    var options = group.querySelectorAll('.fp-bh-option');

    var variantsScript = form.querySelector('[data-fp-bh-color-variants]');
    var optionVariants = [];
    if (variantsScript) {
      try {
        optionVariants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        optionVariants = [];
      }
    }
    var selectedColor = null;
    var selectedSize = null;

    function findOptionVariant(colorValue, sizeValue) {
      var match = optionVariants.filter(function (v) {
        var colorOk = !colorValue || v.colorValue === colorValue;
        var sizeOk = !sizeValue || v.sizeValue === sizeValue;
        return colorOk && sizeOk;
      });
      return match[0] || null;
    }

    function applyVariantSelection() {
      var variant = findOptionVariant(selectedColor, selectedSize);
      if (variant && idInput) idInput.value = variant.id;

      group.querySelectorAll('[data-fp-bh-option-color]').forEach(function (select) {
        if (selectedColor && select.value !== selectedColor) select.value = selectedColor;
      });
      group.querySelectorAll('[data-fp-bh-option-size]').forEach(function (select) {
        if (selectedSize && select.value !== selectedSize) select.value = selectedSize;
      });
    }

    function select(option) {
      options.forEach(function (o) {
        o.classList.toggle('is-selected', o === option);
      });
      if (qtyInput) qtyInput.value = option.getAttribute('data-quantity') || '1';
      if (ctaPrice) ctaPrice.textContent = option.getAttribute('data-price-label') || '';

      if (optionVariants.length) {
        var colorSelect = option.querySelector('[data-fp-bh-option-color]');
        var sizeSelect = option.querySelector('[data-fp-bh-option-size]');
        if (!selectedColor && colorSelect) selectedColor = colorSelect.value;
        if (!selectedSize && sizeSelect) selectedSize = sizeSelect.value;
        applyVariantSelection();
      } else {
        var variantId = option.getAttribute('data-variant-id');
        if (idInput && variantId) idInput.value = variantId;
      }
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        select(option);
      });
      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select(option);
        }
      });
    });

    group.querySelectorAll('[data-fp-bh-option-color], [data-fp-bh-option-size]').forEach(function (fieldSelect) {
      fieldSelect.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      fieldSelect.addEventListener('change', function () {
        if (fieldSelect.hasAttribute('data-fp-bh-option-color')) {
          selectedColor = fieldSelect.value;
        } else {
          selectedSize = fieldSelect.value;
        }
        var option = fieldSelect.closest('.fp-bh-option');
        applyVariantSelection();
        if (option) select(option);
      });
    });

    var initial = group.querySelector('.fp-bh-option.is-selected') || options[0];
    if (initial) select(initial);
  });
});
